import { action, observable } from "mobx";
import { post } from "../../services/ajax-calls.service";
class MedicalClaimsStore {

  @observable highestClaims = []
  @observable claims_timeline = []
  @observable claim_info = {}
  @observable filterValue = "";


  @action indexsortby(filter) {
    this.filterValue = filter;
    if (this.claims_timeline.length > 0) {

      if (filter == "allowed_amount") {
        this.claims_timeline = this.claims_timeline.sort(function (a, b) {
          if (parseInt(a.allowed_amount) > parseInt(b.allowed_amount)) return -1;
          if (parseInt(a.allowed_amount) < parseInt(b.allowed_amount)) return 1;
          return 0
        })
      }
      if (filter == "charges") {
        this.claims_timeline = this.claims_timeline.sort(function (a, b) {
          if (parseInt(a.charges) > parseInt(b.charges)) return -1;
          if (parseInt(a.charges) < parseInt(b.charges)) return 1;
          return 0
        })
      }
      if (filter == "plan_pay") {
        this.claims_timeline = this.claims_timeline.sort(function (a, b) {
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return 1;
          return 0
        })
      }
      if (filter == "co_pay") {
        this.claims_timeline = this.claims_timeline.sort(function (a, b) {
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return 1;
          return 0
        })
      }
    }
  }



  @action getHighestClaims = async (data) => {
    this.highestClaims = [];
    try {
      let response = await post(
        "/api/v1/medicalActions/claims/highestClaims",
        data
      );

      this.highestClaims = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getClaimTimeLine = async (data) => {
    this.claims_timeline = [];
    try {
      let response = await post(
        "/api/v1/medicalActions/claims/getClaimTimeLine",
        data
      );

      this.claims_timeline = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getClaimInfo = async (data) => {
    this.claim_info = {};
    try {
      let response = await post(
        "/api/v1/medicalActions/claims/getClaimInfo",
        data
      );

      this.claim_info = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }

}

export default MedicalClaimsStore;